var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8927_3798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8927_3798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4989 23.3337C14.8933 23.3337 12.6864 22.4295 10.878 20.6212C9.06969 18.8128 8.16553 16.6059 8.16553 14.0003C8.16553 11.4142 9.06969 9.21213 10.878 7.39408C12.6864 5.57602 14.8933 4.66699 17.4989 4.66699C20.085 4.66699 22.2871 5.57602 24.1051 7.39408C25.9232 9.21213 26.8322 11.4142 26.8322 14.0003C26.8322 16.6059 25.9232 18.8128 24.1051 20.6212C22.2871 22.4295 20.085 23.3337 17.4989 23.3337ZM17.4989 21.0003C19.4433 21.0003 21.0961 20.3198 22.4572 18.9587C23.8183 17.5975 24.4989 15.9448 24.4989 14.0003C24.4989 12.0559 23.8183 10.4031 22.4572 9.04199C21.0961 7.68088 19.4433 7.00033 17.4989 7.00033C15.5544 7.00033 13.9016 7.68088 12.5405 9.04199C11.1794 10.4031 10.4989 12.0559 10.4989 14.0003C10.4989 15.9448 11.1794 17.5975 12.5405 18.9587C13.9016 20.3198 15.5544 21.0003 17.4989 21.0003ZM20.153 18.3462L21.8155 16.6837L18.6655 13.5337V9.33366H16.3322V14.4962L20.153 18.3462ZM2.33219 10.5003V8.16699H6.99886V10.5003H2.33219ZM1.16553 15.167V12.8337H6.99886V15.167H1.16553ZM2.33219 19.8337V17.5003H6.99886V19.8337H2.33219Z",
    fill: "#FF8A00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountIcon);
export default __webpack_public_path__ + "static/media/countIcon.a9c5e6a04e956fa1635a7248bf925d9f.svg";
export { ForwardRef as ReactComponent };